import { useEffect } from "react";

import { useGetNotificationsDatabase } from "@/entities/notifications-database";
import { useNotificationsView } from "@/modules/notifications/notifications-view";

export const useNotificationsList = () => {
  const { view, setIsFetching } = useNotificationsView();

  const scrollableTargetId = "notifications-list-target";
  const isUnreadView = view === "unread_tab";
  const readState = isUnreadView ? "unread" : undefined;

  const {
    notifications,
    error,
    isFetching,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useGetNotificationsDatabase({ readState });

  useEffect(() => {
    setIsFetching(isFetching);
  }, [isFetching, setIsFetching]);

  useEffect(() => {
    // Fetch pages to fill the notifications panel height on panel open
    if (!hasNextPage || isFetchingNextPage) return;
    const element = document.getElementById(scrollableTargetId);
    if (!element) return;
    if (element.scrollHeight <= element.clientHeight) fetchNextPage();
  }, [notifications.length, hasNextPage, isFetchingNextPage, fetchNextPage]);

  const onLoadMore = () => {
    if (hasNextPage) fetchNextPage();
  };

  return {
    notifications,
    error,
    isLoading,
    hasNextPage,
    onLoadMore,
    scrollableTargetId,
    isUnreadView,
  };
};
